module.exports = __webpack_public_path__ + "static2023-4-17/img/answer-error_title.5800f269.png";